<script setup>
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import { computed, inject } from 'vue';

// Plugin Hook: Access plugin system for custom channel types
const pluginSystem = inject('pluginSystem', null);

const props = defineProps({
  channelType: {
    type: String,
    required: true,
  },
  medium: {
    type: String,
    default: '',
  },
});
const getters = useStoreGetters();
const { t } = useI18n();
const globalConfig = computed(() => getters['globalConfig/get'].value);

const i18nMap = {
  'Channel::FacebookPage': 'MESSENGER',
  'Channel::WebWidget': 'WEB_WIDGET',
  'Channel::TwitterProfile': 'TWITTER_PROFILE',
  'Channel::TwilioSms': 'TWILIO_SMS',
  'Channel::Whatsapp': 'WHATSAPP',
  'Channel::Sms': 'SMS',
  'Channel::Email': 'EMAIL',
  'Channel::Telegram': 'TELEGRAM',
  'Channel::Line': 'LINE',
  'Channel::Api': 'API',
  'Channel::Instagram': 'INSTAGRAM',
  'Channel::Tiktok': 'TIKTOK',
  'Channel::Voice': 'VOICE',
};

const twilioChannelName = () => {
  if (props.medium === 'whatsapp') {
    return t(`INBOX_MGMT.CHANNELS.WHATSAPP`);
  }
  return t(`INBOX_MGMT.CHANNELS.TWILIO_SMS`);
};

const readableChannelName = computed(() => {
  // Plugin Hook: Check if channel type is registered by a plugin
  if (pluginSystem) {
    const pluginChannelTypes = pluginSystem.getChannelTypes();
    const pluginType = pluginChannelTypes.find(ct => ct.channelType === props.channelType);
    if (pluginType?.i18nKey) {
      return t(`INBOX_MGMT.CHANNELS.${pluginType.i18nKey}`);
    }
  }

  if (props.channelType === 'Channel::Api') {
    return globalConfig.value.apiChannelName || t('INBOX_MGMT.CHANNELS.API');
  }
  if (props.channelType === 'Channel::TwilioSms') {
    return twilioChannelName();
  }
  const i18nKey = i18nMap[props.channelType];
  if (!i18nKey) return props.channelType || '';
  return t(`INBOX_MGMT.CHANNELS.${i18nKey}`);
});
</script>

<template>
  <span>
    {{ readableChannelName }}
  </span>
</template>
